import { StandardTextFieldProps, SxProps, Theme, Typography, Stack, TextField as MuiTextField, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface TextFieldProps extends StandardTextFieldProps {
  name?: string;
  label?: string;
  defaultValue?: string;
  sx?: SxProps<Theme>;
  maxLength?: number;
  visible?: boolean
}

const TextField = ({ name, label, defaultValue, sx = [], maxLength, visible = true, ...props }: TextFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name ? name : ''}
      defaultValue=""
      control={control}
      render={({
        field,
        field: { onChange, value },
        fieldState
      }) => (
        <Stack
          display={visible ? 'flex' : 'none'}
          direction="column"
          spacing={0.5}
          width="100%">
          {label && <Typography variant="primaryFont">{label}</Typography> }
          <MuiTextField
            sx={[
              (theme) => ({
                minWidth: '225px',
                backgroundColor: 'white',
                "& .MuiOutlinedInput-root": {
                  fontFamily: theme.typography.primaryFont,
                  "&.Mui-focused fieldset": {
                    borderColor: theme.colors.primary,
                    borderWidth: '2px'
                  }
                }
              }),
              ...(Array.isArray(sx) ? sx : [sx])
            ]}
            {...field}
            value={value}
            {...props}
            onChange={onChange}
            variant="outlined"
          />
          <Typography
            variant="errorFont">
            {fieldState.error?.message}
          </Typography>
          {(!fieldState.error?.message && props.multiline) && 
            <FormHelperText 
            sx={{ 
              textAlign: 'right'
            }}>
              {value.length} / {maxLength}
            </FormHelperText>
          }
        </Stack>
      )}
    />
  );
}

export default TextField;